/**
 * @typedef {object} NewResearchDocs
 * @property {object} research - Het Research-document om weg te schrijven
 * @property {object} questionnaire - De bijbehorende vragenlijst (Questionnaires)
 */

/**
 * De twee documenten die samen een nieuw onderzoek vormen.
 *
 * Een onderzoek ontstaat altijd mét een vragenlijst; de vragenlijst draagt de
 * titel van het onderzoek. Zonder titel valt het terug op 'Onderzoek N', maar
 * de bouwer vraagt sinds 2026-09-15 eerst om een titel: één klik op de
 * plusknop maakte anders twee documenten aan zonder dat de gebruiker iets had
 * ingevuld (testronde 2026-09-15, B1/B2).
 *
 * @param {object} params
 * @param {string} params.title - Titel uit het venster 'Nieuw onderzoek' (mag leeg zijn)
 * @param {number} params.researchCount - Aantal zichtbare onderzoeken (voor positie en autonaam)
 * @param {number} params.questionnaireCount - Aantal vragenlijsten (voor de positie)
 * @param {string} params.client - CompagnyID
 * @param {*} params.timestamp - Aanmaakmoment
 * @param {string} params.researchID - Nieuw ID voor het onderzoek
 * @param {string} params.questionnaireID - Nieuw ID voor de vragenlijst
 * @returns {NewResearchDocs}
 */
const buildNewResearchDocs = ({ title, researchCount, questionnaireCount, client, timestamp, researchID, questionnaireID }) => {
    const position = (researchCount || 0) + 1
    const researchTitle = String(title || '').trim() || `Onderzoek ${position}`
    const questionnaireTitle = `Vragenlijst voor onderzoek ${researchTitle}`

    return {
        questionnaire: {
            ID: questionnaireID,
            Compagny: client,
            CompagnyID: client,
            Timestamp: timestamp,
            EvidenceBased: false,
            Title: questionnaireTitle,
            Position: (questionnaireCount || 0) + 1,
        },
        research: {
            ID: researchID,
            Compagny: client,
            CompagnyID: client,
            Timestamp: timestamp,
            Title: researchTitle,
            QuestionnaireID: questionnaireID,
            QuestionnaireTitle: questionnaireTitle,
            Position: position,
            SendCopyOption: 'off',
        },
    }
}

export default buildNewResearchDocs
